import { render } from "./login-input.vue?vue&type=template&id=56fc896e&scoped=true"
import script from "./login-input.vue?vue&type=script&lang=js"
export * from "./login-input.vue?vue&type=script&lang=js"

import "./login-input.vue?vue&type=style&index=0&id=56fc896e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fc896e"]])

export default __exports__